import { motion } from "framer-motion";
import { SERVICES } from "../../data";
import { useLang } from "../../i18n";
import { Camera } from "lucide-react";

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="px-6 md:px-12 py-28 md:py-40 bg-[#1A181C] text-[#F9F6F0]">
      <div className="max-w-7xl">
        <p className="overline text-[#E8B059] mb-6">{t.services.overline}</p>
        <h2 className="font-serif-display text-5xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[0.9] mb-16 md:mb-24">
          {t.services.t1} <span className="italic text-[#E2725B]">{t.services.t2}</span><br />{t.services.t3}
        </h2>

        <div className="border-t border-[#F9F6F0]/15">
          {SERVICES.map((s, i) => (
            <motion.div key={s} data-testid={`service-row-${i}`} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: (i % 4) * 0.06 }}
              className="group flex items-center justify-between gap-6 py-7 md:py-9 border-b border-[#F9F6F0]/15 cursor-default">
              <div className="flex items-baseline gap-6 md:gap-10">
                <span className="overline text-[0.6rem] text-[#E8B059]/70">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-serif-display text-3xl md:text-6xl font-light tracking-tight transition-colors duration-300 group-hover:text-[#E2725B]">{s}</span>
              </div>
              <Camera className="w-6 h-6 md:w-8 md:h-8 opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-400 text-[#E2725B]" strokeWidth={1} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
